import axiosInstance from "../config/axiosInstance"





export const sellYourBusiness = async ({ 

     businessName,
            gstNumber,
            entityType,
            businessCategory,
           
    
            address,
            street,
            city,
            state,
            country,
            postalCode,
    
    
            businessOverview,
            businessDetails,
         
         
            logoPhotoUrl,
            businessPhotoUrl,
            
            areaSqFt,
            typeOfBusinessPremises,
            annualSales,
    
    
            
            reasonToSell,
            quotedValue,
            grossIncome,
            ebitda,
            rentals,
            noOfEmployees,
            agreementToPrivacyPolicy,
            acceptanceOfTermsAndConditions,
    
    
            user,
            plan,
            payment_status,
            status,
            madeBy

}) => {
    const formdata = new FormData();
 if (businessName) formdata.append("businessName", businessName);
 if(gstNumber)   formdata.append('gstNumber', gstNumber);
    if(entityType) formdata.append('entityType', entityType);
   if(businessCategory)  formdata.append('businessCategory', businessCategory);
    if(address) formdata.append('address', address);
   if(street)  formdata.append('street', street);
   if(city)  formdata.append('city', city);
   if(state)  formdata.append('state', state);
   if(country)  formdata.append('country', country);
   if(postalCode)  formdata.append('postalCode', postalCode);
   if(businessOverview)  formdata.append('businessOverview', businessOverview);
   if(businessDetails)  formdata.append('businessDetails', businessDetails);
    if(logoPhotoUrl) formdata.append('logoPhotoUrl', logoPhotoUrl);
   if(businessPhotoUrl)  formdata.append('businessPhotoUrl', businessPhotoUrl);
   if(areaSqFt)  formdata.append('areaSqFt', areaSqFt);
   if(typeOfBusinessPremises)  formdata.append('typeOfBusinessPremises', typeOfBusinessPremises);
   if(annualSales)  formdata.append('annualSales', annualSales);
   if(reasonToSell)  formdata.append('reasonToSell', reasonToSell);
   if(quotedValue)  formdata.append('quotedValue', quotedValue);
    if(grossIncome) formdata.append('grossIncome', grossIncome);
   if(ebitda)  formdata.append('ebitda', ebitda);
   if(rentals)  formdata.append('rentals', rentals);
   if(noOfEmployees)  formdata.append('noOfEmployees', noOfEmployees);
   if(agreementToPrivacyPolicy)  formdata.append('agreementToPrivacyPolicy', agreementToPrivacyPolicy);
   if(acceptanceOfTermsAndConditions)  formdata.append('acceptanceOfTermsAndConditions', acceptanceOfTermsAndConditions);
   if(user)  formdata.append('user', user);
   if(plan)  formdata.append('plan', plan);
   if(payment_status)  formdata.append('payment_status', payment_status);
   if(status)  formdata.append('status', status);
   if (madeBy) formdata.append('madeBy', madeBy);
    
    const response = await axiosInstance.post(`/api/admin/create/createsellyourbusiness`, formdata, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
    return response;
}